export default {
	'home-page': '',
	'news-page': '',
	'seo-fields': ''
}